import type { CustomerNotification } from '@/entities/customer-notification/api/customer-notifications/types';

/** Odd/even split — same as contact masonry columns (newest first). */
export const splitNewsColumns = (data: CustomerNotification[]) => {
    const left: CustomerNotification[] = [];
    const right: CustomerNotification[] = [];
    for (let i = 0; i < data.length; i++) {
        (i % 2 === 0 ? left : right).push(data[i]!);
    }
    return [left, right] as const;
};

export type NewsScrollAnchor = {
    id: string;
    offsetWithinRow: number;
};

export const findNewsItemIndex = (
    items: CustomerNotification[],
    id: string | null | undefined,
): number | null => {
    if (!id) return null;
    const index = items.findIndex((item) => item.id === id);
    return index >= 0 ? index : null;
};
